<template>
     
  <v-avatar class="profile-avatar mb-3" :size="width">
           
    <slim-cropper :options="slimOptions" :style="'width: ' + width + 'px; height: ' + height + 'px;'">
                              <img v-if="initialPicture" :src="'/img/profilbilder' + initialPicture" alt="Gruppenbild" />            
      <input type="file" accept="image/*" />        
    </slim-cropper>
       
  </v-avatar>
</template>

<script>
// Importiert dein Slim Cropper Plugin
import Slim from "@/plugins/slimImage/slim/slim.vue"
// Importiert deine zentrale API-Datei
import api from "@/api"

export default {
  name: "ChatGroupPicture",
  props: {
    /**
     * Die _id der Chat-Gruppe, die bearbeitet wird.
     * Wird für die API-Route 'upload/chat_group_bild/:groupId' benötigt.
     */
    groupId: {
      type: String,
      required: true,
    },
    /**
     * Das *aktuelle* Bild der Gruppe (z.B. '/uploads/bild.webp')
     * Wird als Vorschau im Cropper angezeigt.
     */
    initialPicture: {
      type: String,
    },
    width: {
      type: Number,
      default: 125,
    },
    height: {
      type: Number,
      default: 125,
    },
  },
  components: { "slim-cropper": Slim },
  methods: {
    /**
     * Diese Methode wird vom Slim Cropper als 'service' aufgerufen.
     */
    uploadPicture(formdata, progress, success, failure, slim) {
      const formData = new FormData()
      formData.append("file", formdata[0])

      let uploadimg = {}

      // --- DER ENTSCHEIDENDE UNTERSCHIED ---
      uploadimg.art = "chat_group_bild" // 1. Neue Art
      uploadimg.groupId = this.groupId // 2. Wir übergeben die Gruppen-ID
      // --- ENDE ---

      uploadimg.formData = formData
      api
        .uploadImage(uploadimg)
        .then((data) => {
          if (data.status) {
            // Sende den NEUEN Bild-Pfad (z.B. '/uploads/bild.webp')
            // an die Eltern-Komponente (das Dialog-Fenster)
            this.$emit("updatedPicture", data.name)
            success(data)
          }
        })
        .catch((error) => {
          failure(error)
          console.log(error)
        })
    },
  },
  computed: {
    /**
     * Konfiguration für den Slim Cropper
     */
    slimOptions() {
      return {
        ratio: "1:1", // Quadratisch
        buttonCancelLabel: "Abbrechen",
        buttonConfirmLabel: "Bestätigen",
        "data-button-remove-label": false,
        label: "Bild hochladen",
        "data-edit": false,
        buttonUpload: true,
        dataRemove: false,
        labelLoading: "Bild wird hochgeladen",
        statusUploadSuccess: "gespeichert",
        service: this.uploadPicture, // <-- Nutzt unsere angepasste Methode
        serviceFormat: "file",
        dataJpegCompression: 70,
        instantEdit: true,
        push: true, // FIX: Zeigt das aktuelle Gruppenbild ODER den Placeholder
        initialImage: this.initialPicture || "/img/einmalig/imageUploadPlaceholderPFP.jpg",
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
